import type { PlayerReport } from "./reports"
import type { ModerationIncident } from "./storage"

export function summarizeSafetyStats(
  incidents: readonly ModerationIncident[],
  reports: readonly PlayerReport[],
) {
  const incidentTotals = {
    total: incidents.length,
    pending: incidents.filter((incident) => incident.status === "pending")
      .length,
    confirmed: incidents.filter((incident) => incident.status === "confirmed")
      .length,
    dismissed: incidents.filter((incident) => incident.status === "dismissed")
      .length,
  }

  const reportTotals = {
    total: reports.length,
    pending: reports.filter((report) => report.status === "pending").length,
    reviewed: reports.filter((report) => report.status === "reviewed").length,
    dismissed: reports.filter((report) => report.status === "dismissed").length,
  }

  const latestEventAt =
    [
      ...incidents.map((incident) => incident.updatedAt),
      ...reports.map((report) => report.updatedAt),
    ].sort((left, right) => right.localeCompare(left))[0] ?? null

  return {
    incidentTotals,
    reportTotals,
    uniqueActors: new Set(
      incidents
        .map((incident) => incident.actorEmail)
        .filter((value): value is string => Boolean(value)),
    ).size,
    uniqueReporterTags: new Set(reports.map((report) => report.reporterTag))
      .size,
    uniqueReportedTags: new Set(reports.map((report) => report.reportedTag))
      .size,
    latestEventAt,
  }
}
